// extracted by mini-css-extract-plugin
module.exports = {"termlist":"TermsAndConditionOnline_termlist__2mDys","checkagreement":"TermsAndConditionOnline_checkagreement__36E0D"};